var exports = {
  "iE": "xaee3c4fa--07933e--wrapper",
  "Kk": "xaee3c4fa--07933e--icon",
  "Qq": "xaee3c4fa--07933e--text",
};

module.exports = exports;
